import { useState } from 'react'
import { CustomTooltips } from './CustomTooltips';
import Joyride, { ACTIONS, EVENTS, CallBackProps, TooltipRenderProps } from 'react-joyride'
import { TypingResultTutorialTypeEnum } from '../../../../api';
import { TUTORIAL_STEPS } from './Consts';

interface TutorialProps {
  tutorialType: TypingResultTutorialTypeEnum;
  tutorialEndCallback: () => void;
}

export const Tutorial = ({ tutorialType, tutorialEndCallback }: TutorialProps) => {
  const [spotlightClicks, setSpotlightClicks] = useState<boolean>(false)
  const [stepIndex, setStepIndex] = useState<number>(0)
  const handleJoyrideCallback = (data: CallBackProps) => {
    const { action, index, type } = data;
    if (type === EVENTS.STEP_AFTER || type === EVENTS.TARGET_NOT_FOUND) {
      const currentIndex = index + (action === ACTIONS.PREV ? -1 : 1);
      setStepIndex(currentIndex);
      const stepsCount = TUTORIAL_STEPS[tutorialType].length;
      if (currentIndex + 1 === stepsCount) {
        setSpotlightClicks(true);
      } else if (currentIndex >= stepsCount) {
        tutorialEndCallback();
      }
    }
  };
  return (
    <Joyride
      steps={TUTORIAL_STEPS[tutorialType]}
      stepIndex={stepIndex}
      spotlightClicks={spotlightClicks}
      run={true}
      continuous
      tooltipComponent={(props: TooltipRenderProps) => (
        <CustomTooltips {...props}/>
      )}
      callback={handleJoyrideCallback}
      disableOverlayClose
      disableCloseOnEsc
      hideBackButton
      hideCloseButton
      disableScrollParentFix
      disableScrolling
      scrollToFirstStep={false}
    />
  );
};